import { createSelector } from 'reselect';
import { Tier } from 'features/premium/entities';
import { NordVPNStatusEnum } from 'features/NordVpn/types';
import { selectVpnStatus } from 'features/NordVpn/selectors';
import { selectSpacesCreatedByUser } from 'features/spaces/reducers/selectors';
import { selectOrderedActiveSubscriptions } from 'features/subscriptions/selectors';
import { selectOrderedConnections, selectFilledExtraMemberSeats, selectAllManualAccountsCreatedByUser, } from '../selectors';
export const selectFeaturesUsedWhenOnPremium = createSelector([
    (store) => store.user.tierBeforeDowngradingToBasic,
    selectSpacesCreatedByUser,
    selectFilledExtraMemberSeats,
    selectVpnStatus,
    selectOrderedActiveSubscriptions,
    (store) => store.transactions.transactionsArray,
    selectAllManualAccountsCreatedByUser,
    (store) => selectOrderedConnections(store),
    (store) => store.rentReporting.data,
    (store) => store.unpersistedUtils.monthlyTotalsForLatestPeriod,
], (tierBeforeDowngradingToBasic, spaces, filledExtraMemberSeats, nordVpnStatus, subscriptions, transactions, manualAccounts, connections, rentReportingData, monthlyTotalsForLatestPeriod) => {
    if (!tierBeforeDowngradingToBasic)
        return undefined;
    const features = [];
    if (tierBeforeDowngradingToBasic === Tier.ultimate) {
        if (spaces.length) {
            features.push({
                type: 'spaces',
                data: spaces,
            });
        }
        if (filledExtraMemberSeats?.length) {
            features.push({ type: 'extraMembers', data: filledExtraMemberSeats });
        }
        if (nordVpnStatus !== NordVPNStatusEnum.NOT_REGISTERED) {
            features.push({
                type: 'nordVPN',
                data: NordVPNStatusEnum.ACTIVE,
            });
        }
    }
    if (subscriptions.length > 2) {
        features.push({
            type: 'subscriptions',
            data: subscriptions,
        });
    }
    if (rentReportingData?.current) {
        features.push({
            type: 'rentReporting',
            data: rentReportingData.current,
        });
    }
    if (monthlyTotalsForLatestPeriod?.totalBudget) {
        features.push({
            type: 'budgeting',
            data: {
                monthlyTotals: monthlyTotalsForLatestPeriod,
            },
        });
    }
    if (transactions.length) {
        features.push({ type: 'transactions', data: transactions });
    }
    if (manualAccounts.length && tierBeforeDowngradingToBasic !== Tier.plus) {
        features.push({
            type: 'manualAccounts',
            data: manualAccounts,
        });
    }
    if (connections.length > 2) {
        features.push({ type: 'connections', data: connections });
    }
    return features;
});
